import React from 'react';
import { isNil } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import TextField, { OutlinedTextFieldProps } from '@material-ui/core/TextField';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export type Props = Omit<OutlinedTextFieldProps, 'variant'> & { displayValue?: string };

const useStyles = makeStyles(theme => ({
  placeholder: { color: '#696969' },
  icon: {
    color: theme.palette.common.black,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.pxToRem(15),
    top: 'unset',
    right: 12
  }
}));

const getRenderValueFn = (
  placeholder?: string,
  value?: any,
  displayValue?: any
): ((value: any) => React.ReactNode) | undefined => {
  // If no placeholder value is specified or a specific value is selected, no renderValue should be specified.
  if (!displayValue && (!placeholder || (value !== '' && !isNil(value)))) return;

  const renderValueFn = (): React.ReactNode => displayValue || placeholder;
  return renderValueFn;
};

const Select = ({
  children,
  onChange,
  placeholder = '',
  SelectProps = {},
  value,
  displayValue,
  ...rest
}: Props) => {
  const styles = useStyles();
  const { classes, ...selectProps } = SelectProps;
  const renderValue = getRenderValueFn(placeholder, value, displayValue);

  return (
    <TextField
      select
      fullWidth
      value={value}
      variant="outlined"
      SelectProps={{
        displayEmpty: !!placeholder,
        renderValue,
        IconComponent: ExpandMoreIcon,
        classes: { ...classes, icon: styles.icon, outlined: styles.placeholder },
        ...selectProps
      }}
      onChange={onChange}
      {...rest}
    >
      {children}
    </TextField>
  );
};

export default Select;
